module.exports = __webpack_public_path__ + "img/nest.7663ea7b.png";